import Joi from 'joi';

import { fileSchema } from '../../../../shared/modules/files/validators/schemas/file.schema';
import { createTagsSchema } from '../../../tags/validators/schemas/create-tags.schema';

/**
 * Schema for new vehicle group record validation.
 */
export const createVehicleGroupSchema = () =>
  Joi.object({
    uuid: Joi.alternatives()
      .conditional(Joi.any().valid(null), {
        then: Joi.invalid(null).messages({
          'any.invalid': 'validations|vehicle-group-uuid|cannot-be-null',
        }),
        otherwise: Joi.string().required().messages({
          'any.required': 'validations|vehicle-group-uuid|required',
          'string.base': 'validations|vehicle-group-uuid|must-be-string',
          'string.empty': 'validations|vehicle-group-uuid|cannot-be-empty',
        }),
      })
      .required()
      .messages({
        'any.required': 'validations|vehicle-group-uuid|required',
      }),
    name: Joi.alternatives()
      .conditional(Joi.any().valid(null), {
        then: Joi.invalid(null).messages({
          'any.invalid': 'validations|vehicle-group-name|cannot-be-null',
        }),
        otherwise: Joi.string().required().messages({
          'any.required': 'validations|vehicle-group-name|required',
          'string.base': 'validations|vehicle-group-name|must-be-string',
          'string.empty': 'validations|vehicle-group-name|cannot-be-empty',
        }),
      })
      .required()
      .messages({
        'any.required': 'validations|vehicle-group-name|required',
      }),
    description: Joi.string().allow(null, '').messages({
      'string.base': 'validations|vehicle-group-description|must-be-string',
    }),
    notes: Joi.string().allow(null, '').messages({
      'string.base': 'validations|vehicle-group-notes|must-be-string',
    }),
    files: Joi.array().items(fileSchema()).allow(null).messages({
      'array.base': 'validations|vehicle-group-files|invalid-value',
    }),
    tags: createTagsSchema().allow(null).messages({
      'array.base': 'validations|vehicle-group-tags|invalid-value',
    }),
  }).unknown();
